import React, {Fragment} from 'react';
import Header from '../../components/header'
// import PageTitle from '../../components/pagetitle'
import VedioCta from '../../components/vediocta'
// import Mission from '../../components/mission'
import AboutExtended from '../../components/about-us'
import Founder from '../../components/founder'
import DonateSection from '../../components/DonateSection'
// import CaseSlide from '../../components/case'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import vimg from '../../images/thumbnail.jpg'

const CasePage =() => {
    return(
        <Fragment>
            <Header/>
            {/* <PageTitle pageTitle={'About Us'} pagesub={'About'}/>  */}
            <VedioCta videoId={'64KPWgiP8c8'} videoImg={vimg}/>
            {/* <Mission subclass={'section-padding'}/> */}
            {/* <About/> */}
            <AboutExtended/>
            <Founder/>
            <DonateSection/>
            {/* <CaseSlide/> */}
            {/* <CounterSection/> */}
            {/* <TeamSection/> */}
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default CasePage;
